import React, { Component } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
// import {TableComp} from 'sz-react-utils'
import TableComp from "../../../../components/_utils/table";
import { getUrlPushWrapper, getUrlQuery } from "../../../../routes";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import { FaUserEdit } from "react-icons/fa";
import moment from "moment";
import ListFollowUps from "../../../../components/_utils/listFollowUp";
import { RightsWrapper } from "../../../../components/_utils/utils";
import LeadImportExcel from '../../../../assets/samplesFiles/leadImport.xlsx'
import _ from 'lodash'
import {
  Avatar,
  Button,
  Card,
  Checkbox,
  DatePicker,
  Col,
  notification,
  Popconfirm,
  Row,
  Select,
  Tooltip,
  Drawer,
  Form,
  Input
} from "antd";
import Request, { API_URL, LAPI_URL } from "../../../../request";
import Settings from "../../../../components/_utils/settings";
import lodash from "lodash";
import { connect } from "react-redux";
import styles from "./styles.less";
import common from "../../../common.less";
import LatestFollowUp from "../../../../components/_utils/latestFollowup";
import SMS from "../../../../components/communication/sms";
import WhatsAPPSMS from "../../../../components/communication/WhatsAppSms";
import EmailDrawer from "../../../../components/communication/emailDrawer";
import ChangeBranch from "./changeBranch";
import ChangeQuickDetails from "./changeQuickDetails";
import ClickToCallDrawer from "./clickToCall";
import { hideLoader, showLoader } from "../../../../modules/actions";
import ChangeCounsellorAndDesk from "../../../../components/_utils/changeCounsellorAndDesk";
import rightAuth from "../../../../components/_utils/userRights";
import { mapValuesSeries } from "async";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let counsellingData = {};
const showDroppedLeads = rightAuth.checkUserRights('showDropLead')

const showDropLead = rightAuth.checkUserRights('dropLead')
let studentObj = {};

const { RangePicker } = DatePicker;
const { Search } = Input
const Option = Select.Option;

let localUser = JSON.parse(localStorage.getItem('user'))


let desks = {
  'Front Desk': '/desk/update-counselling',
  'Registration Desk': '/registration/fees',
  'Application Desk': '/desk/allApplication-desk/update',
  'Visa Desk': '/desk/getVisa',
  'Claim Desk': '/desk/getClaim',
  'Operation Manager Desk': '/operation-manager-inquiry/update'
};

let userCheckBox = {};


// @Form.create()
// class ClickToCallDrawer extends Component {
//   state = {
//     visible: true,
//     callStatus:null,
//   }

//   onClose =() =>{
//     this.setState({visible:false})
//     setTimeout(()=>{
//       this.props.onClose()
//     },50)
//   }

//   updateCallStatus(e) {
//     console.log(e.target.value)
//   }

//   handleSubmit = (e) =>{
//     let {form, record} = this.props;
//     e.preventDefault();
//     form.validateFieldsAndScroll(async(err,valData)=>{
//       let values = _.clone(valData)
//       values.studentId = record._id;
//       values.studentMobile = record.mobile;
//       let response = await Request.addCallDetail(values);
//       if(response.success) {
//         notification.success({
//           message:response.message
//         })
//       }else {
//         notification.error({
//           message:response.message
//         })
//       }
//       this.onClose()
//     })
//   }

//   render() {
//     let {record, form:{getFieldDecorator, setFieldsValue}} = this.props;
//     let {visible, callStatus} = this.state;
//     let inputTypes = {
//       fields:[
//         {
//           label:'Call Status',
//           key:'callStatus',
//           type:'select',
//           required:true,
//           options:['Connected', 'Not Connected'],
//           onChange:v=>{
//             setFieldsValue({callStatus:v})
//             this.setState({callStatus:v})
//           }
//         },
//         {
//           label:'Question 1',
//           key:'question1',
//           type:'textarea',
//           required:callStatus === "Connected"?true:false,
//           hidden:callStatus === "Connected"?false:true
//         },
//         {
//           label:'Question 2',
//           key:'question2',
//           type:'textarea',
//           required:callStatus === "Connected"?true:false,
//           hidden:callStatus === "Connected"?false:true
//         },
//         {
//           label:'Question 3',
//           key:'question3',
//           type:'textarea',
//           required:callStatus === "Connected"?true:false,
//           hidden:callStatus === "Connected"?false:true
//         }
//       ]
//     }
//     return (
//       <Drawer
//         title={
//           <div>
//             {`Call Details:- ${record.studentName} ${record.countryCode}-${record.mobile}`}
//           </div>
//         }
//         placement="right"
//         closable={true}
//         width={500}
//         onClose={this.onClose}
//         visible={this.state.visible} >
//           <Card>
//                 <Form onSubmit={this.handleSubmit}>
//                 <GetAllFormFields apiurl={API_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
//                 <Row style={{marginTop:'20px'}}>
//                             <Col span={8}/>
//                             <Col span={8}>
//                                 <Button
//                                     type="primary"
//                                     htmlType="submit"
//                                     style={{marginBottom: 10}}
//                                     loading={this.props.loading}>
//                                     Save
//                                 </Button>
//                             </Col>
//                             <Col span={8}/>
//                         </Row>
//                 </Form>
//           </Card>
//         </Drawer>
//     )
//   }
// }


@Form.create()
class AllInquiry extends Component {
  state = {
    search_keyword: '',
    count: 0,
    showFollowUp: false,
    studentId: null,
    allDesks: Settings.allDesks,
    deskNameObj: Settings.deskNameObj,
    deskId: "",
    counsellorId: "",
    counsellors: [],
    allCounsellor: [],
    allBranches: [],
    testTypeList: [],
    deleteLoading: false,
    branchId: "",
    deskColor: null,
    userCheckBox: {},
    showSMS: false,
    showWhatsAppSms: false,
    showEmail: false,
    showDate: true,
    showCallDrawer: false,
    recordForCall: {},
    showRegiDate: false,
    channelPartnerList: [],
    countriesArr: [],
    time: {
      key: "time",
      $gte: "",
      $lt: "",
    },
    registrationTime: {
      $gte: "",
      $lt: "",
    },
    ratingArr: [],
    ratingsObject: [],
    subRatingArr: [],
    subRatingsObject: [],
    leadStatusArr: [],
    leadStatusesObject: [],
    modeArr: [],
    inquiryArr: ["COACHING", "STUDENT"],
    countryArr: [],
    drawer: false,
    drawerParam: null,
    isFollowUpOverdue: false,
    updateQuickDetailsDrawer: false,
    visible1: false,
    showMissingQual: false,
    showDropped: false,
    showChangeMultipleCounsellor: false,
    pathName: null,
    studentList: null,
    loading: false,
    followDuesCount: 0
  };
  showSMS = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showSMS: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  closeSMS = () => {
    this.setState({ showSMS: false });
  };
  showWhatsAppSms = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showWhatsAppSms: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  closeWhatsSMS = () => {
    this.setState({ showWhatsAppSms: false });
  };
  closeEmail = () => {
    this.setState({ showEmail: false });
  };
  showEmail = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showEmail: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };

  deleteStudent = async (_id) => {
    this.setState({ deleteLoading: true });
    let x = await Request.deleteStudent({ _id: _id, atLevel: "Deleted" });
    this.setState({ deleteLoading: false });
    if (x && !x.error) {
      notification.success({
        message: "Deleted Successfully",
      });
      this.table.current.reload();
    } else {
      notification.error({ message: "Try again" });
    }
  };

  changeMultipleCounsellorAndDesk = async () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showChangeMultipleCounsellor: true });

    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }

  closeChangeMultipleCounsellorDrawer = async () => {
    this.setState({ showChangeMultipleCounsellor: false, userCheckBox: {} }, () => {
      counsellingData = {};
      this.reload();
    })
  }

  dropLeads = async () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      let response = await Request.dropInquiry(counsellingData)
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          message: 'Something Went Wrong'
        })
      }
      this.setState({ userCheckBox: {} }, () => {
        this.reload()
      })

    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }

  toggleDroppedLeads = () => {
    let showDropped = this.state.showDropped;
    showDropped = !showDropped
    this.setState({ showDropped }, () => {
      this.reload()
    })
  }

  constructor(props) {
    super(props);
    this.table = React.createRef();
    this.followUpsCallback = this.followUpsCallback.bind(this);
    Request.getCounsellorsUsers()
      .then((resp) => {
        if (resp) {
          let temp = [{ display: "---Show All---", id: "" }];
          resp.data = resp.data.reduce((el, vv) => {
            vv.display = vv.name;
            vv.id = vv._id;
            temp.push(vv);
            return temp;
          }, []);
          this.setState({ counsellors: resp.data });
        }
      })
      .catch((err) => { });
  }

  openFollowUps = (record) => {
    studentObj = {
      arr: record.followUp,
      name: record.studentName,
      rating: record.counsellingDesk.rating,
      subRating: record.counsellingDesk.subRating,
      _id: record._id,
    };

    this.setState({ showFollowUp: true });
  };
  renderStatus = (val) => {
    if (val === "Super Hot") {
      return <div className={styles.SuperHot}>{val.toUpperCase()}</div>;
    }
    if (val === "Fit2Apply") {
      return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>;
    }

    if (val === "Neutral") {
      return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>;
    }

    if (val === "Potential") {
      return <div className={styles.Potential}>{val.toUpperCase()}</div>;
    }

    if (val === "Dead") {
      return <div className={styles.dead}>{val.toUpperCase()}</div>;
    }

    if (val === "Cold") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
    if (val === "Active") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
  };

  apiRequest = (params, columns) => {
    return new Promise(async (resolve) => {
      params.dropped = this.state.showDropped
      let pathName = this.props.location.pathname;
      if (pathName === "/allLeads") {
        params.atLevels = ["Operation Manager Desk", "Front Desk", "Registration Desk"]
      } else if (pathName === "/allStudents") {
        params.atLevels = ["Application Desk", "Visa Desk", "Claim Desk", "Archive Desk"]
      }
      if (params.atLevel && params.atLevel.length > 0) {
        // Save them separately so backend can merge
        params.userAtLevels = params.atLevel;
        delete params.atLevel;
      }
      if (!params.sortField) {
        params.sortField = "id";
        params.sortOrder = "descend";
      }
      if (this.state.search_keyword && this.state.search_keyword !== "") {
        params.keyword = this.state.search_keyword
      }
      if (this.state.deskId) {
        params.atLevel = this.state.deskId;
        params.page = 1;
      }
      if (this.state.counsellorId) {
        params.counsellorId = this.state.counsellorId;
        params.page = 1;
      }

      if (this.state.branchId) {
        params.studentBranchId = this.state.branchId;
        params.page = 1;
      }
      if (this.state.singleRatingFilter) {
        params["counsellingDesk.rating"] = this.state.singleRatingFilter;
      }
      if (this.state.showMissingQual) {
        params.showMissingQual = this.state.showMissingQual
      }

      if (params.dateOfBirth && params.dateOfBirth.length > 0) {
        var splitDate = params.dateOfBirth[0].split("-");
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var monthName = monthNames[splitDate[1] - 1];

        params.dateOfBirth =
          splitDate[0] + "-" + monthName + "-" + splitDate[2];

        const stringToDate = new Date(params.dateOfBirth);
        params.dateOfBirth = {
          $gte: moment(params.dateOfBirth, dateFormat).startOf('day'),
          $lt: moment(params.dateOfBirth, dateFormat).endOf('day')
        };
      } else {
        delete params.dateOfBirth;
      }

      if (this.state.isFollowUpOverdue) {
        params.isFollowUpOverdue = this.state.isFollowUpOverdue;
      }


      let data = await Request.getAllStudentList({
        ...params,
        regExFilters: ["studentName", "watsupp", "mobile"],
        InquiryDate: this.state.time,
        registrationTime: this.state.registrationTime,
      });

      delete data.error;
      delete data.type;
      lodash.each(data.data, (item) => {
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            _id: item._id,
            emailId: item.emailId,
            mobile: item.mobile,
            studentName: item.studentName,
            isChecked: false,
          };
        }
      });

      this.setState({
        count: data.total,
        allBranches: data.allBranches,
        userCheckBox: userCheckBox,
      });
      resolve(data);
    });
  };


  closeFollowUp = () => {
    this.setState({ showFollowUp: false });
  };
  returnDeskName = (record) => {
    const deskConfig = Settings.allDesks;

    let findIn = lodash.find(deskConfig, (rr) => {
      return rr.name == record.atLevel;
    });

    if (findIn) {
      return (
        <div
          style={{
            backgroundColor: findIn.color,
            color: "white",
            padding: 3,
            display: "inline-block",
            fontWeight: "bold",
          }}
        >
          {
            localUser.isFinanceAdmin || localUser.isFinanceAdmin ?
              <a
                style={{ color: 'white' }}
                size={"small"}
                href={(record.atLevel && desks[record.atLevel] ? desks[record.atLevel] : 'documents') + "?id=" + record._id}
              >{Settings.deskNameObj[record.atLevel]}</a>
              :
              Settings.deskNameObj[record.atLevel]
          }
        </div>
      );
    } else {
      return <div>{record.atLevel}</div>;
    }
  };
  selectUser = (item, studentId) => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId]
      .isChecked;
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  selectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = true;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  unselectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = false;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };

  followUpExtendedDate = (followUp) => {
    if (followUp && followUp.followUpDate) {
      return moment(
        moment(new Date()).format("YYYY-MM-DD[T00:00:00.000Z]")
      ).isAfter(followUp.followUpDate);
    }
  };

  componentWillMount() {
    let searchParams = new URLSearchParams(this.props.search);

    let singleRatingFilter = searchParams.get("rating");
    if (singleRatingFilter) {
      this.setState({ singleRatingFilter: singleRatingFilter });
    }
  }

  loadChannelPartners = async () => {
    let { data: channelPartnerList } = await Request.getSimplePartners({
      results: 10000,
      sortField: 'channelPartnerName',
      sortOrder: 'ascend'
    })
    this.setState({ channelPartnerList });
  }

  async componentDidMount() {
    this.loadUserRights();
    this.loadChannelPartners();
    this.loadCountry();
    let pathName = this.props.location.pathname;
    window.onkeydown = function (e) {
      var ck = e.keyCode ? e.keyCode : e.which;
      if (e.ctrlKey && ck == 70) {
        if (document.querySelector('#search-student-input')) {
          document.querySelector('#search-student-input').focus();
        }
        return false;
      } else if (ck == 27) {
        if (document.querySelector('#search-student-input')) {
          document.querySelector('#search-student-input').focus();
        }
        return false;
      }
    }
    await this.getAllRatings();
    await this.getAllSource();
    await this.getAllTestTypes();
    let {
      data: allCounsellor,
    } = await Request.loadCounsellorListForStudentRights({
      results: 10000,
    });
    this.setState({
      allCounsellor,
    });

    let {
      data: allOperationManager,
    } = await Request.getOperationManagerListForStudentRights({
      results: 10000,
    });
    this.setState({
      allOperationManager,
      pathName,
    });
  }
  getAllTestTypes = async () => {
    let response = await Request.getAllTestTypes({
      results: 1000,
      count: 1000
    });
    if (response && response.data) {
      let testTypeList = [];
      testTypeList.push({ value: 'NO', text: 'Never' })
      response.data.map((testTypeData) => {
        testTypeList.push({ value: testTypeData.testType, text: testTypeData.testType })
      })
      this.setState({
        testTypeList: testTypeList
      });
    }
  }
  getAllSource = async () => {
    let response = await Request.getSourceDetails({
      results: 1000,
      count: 1000,
    });
    let sourceObject = [];
    response.data &&
      response.data.map((source) => {
        sourceObject.push(source.sourceName);
      });
    this.setState({ modeArr: sourceObject });
  };

  handleStudentMove = async (data) => {
    let response = await Request.moveStudentToVisitorVisa(data);
    if (!response.error) {
      notification.success({
        message: response.message,
      });
    } else {
      notification.error({
        message: response.message,
      });
    }
    this.reload()
  };

  getAllRatings = async () => {
    let response = await Request.getRatingsDetails({
      results: 1000,
      count: 1000,
    });
    let ratingsObject = [];
    response.data &&
      response.data.map((rating) => {
        ratingsObject[rating._id] = rating;
      });

    let subResponse = await Request.getSubRatingsDetails({ results: 1000, count: 1000 });
    let subRatingsObject = [];
    subResponse.data && subResponse.data.map(r => { subRatingsObject[r._id] = r; });

    let lsResponse = await Request.getLeadStatusDetails({ results: 1000, count: 1000 });
    let leadStatusesObject = [];
    lsResponse.data && lsResponse.data.map(l => { leadStatusesObject[l._id] = l; });

    this.setState({
      ratingArr: response.data,
      ratingsObject: ratingsObject,
      subRatingArr: subResponse.data,
      subRatingsObject,
      leadStatusArr: lsResponse.data,
      leadStatusesObject
    });
  };

  loadCountry(callback) {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
    };

    Request.getCountriesWithoutAuth(params)
      .then((resp) => {
        if (resp) {
          let temp = [];
          lodash.each(resp.data, (vv) => {
            temp.push({
              text: vv.countryName,
              value: vv._id,
            });
          });
          this.setState({ countriesArr: temp })
        } else {
          return callback([]);
        }
      })
      .catch((err) => {
        return callback([]);
      });
  }

  chooseRangerPicker = (date, dateString) => {
    this.state.showDate = true;

    this.setState(
      {
        time: {
          key: "time",
          $gte: moment(date[0]).startOf('day'),
          $lt: moment(date[1]).endOf('day'),
        },
      },
      () => { }
    );
    setTimeout(() => {
      this.reload();
    }, 500);
  };
  chooseRegistrationPicker = (date, dateString) => {
    this.state.showDate = true;

    this.setState(
      {
        registrationTime: {
          $gte: moment(date[0]).startOf('day'),
          $lt: moment(date[1]).endOf('day'),
        },
      },
      () => { }
    );
    setTimeout(() => {
      this.reload();
    }, 500);
  };

  reload = () => {
    this.table.current.reload();
  };

  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()

    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {

        let values = _.clone(valData)

        let x = null
        x = await Request.addInquiryThroughExcel(values.excelFile[0].response)

        if (!x.error) {
          notification.success({
            message: x.message
          })

          this.setState({ visible1: false })
          this.table.current.reload()
        } else {
          notification.error({
            message: x.message

          })
        }
      }
    })
  }

  closeCallDrawer = () => {
    this.setState({ showCallDrawer: false, recordForCall: {} }, () => {
      this.reload()
    })
  }

  getAtStageFilters = () => {
    const pathName = this.props.location.pathname;
    if (pathName === "/allLeads") {
      return [
        { text: 'Operation Manager Desk', value: 'Operation Manager Desk' },
        { text: 'Counselling Desk', value: 'Front Desk' },
        { text: 'Registration Desk', value: 'Registration Desk' },
      ];
    }
    if (pathName === "/allStudents") {
      return [
        { text: 'Application Desk', value: 'Application Desk' },
        { text: 'Visa Desk', value: 'Visa Desk' },
        { text: 'Claim Desk', value: 'Claim Desk' },
        { text: 'Archive Desk', value: 'Archive Desk' },
      ];
    }
    return []; // default
  };


  changeSearchValue = (value) => {
    this.setState({ search_keyword: value }, () => {
      this.table.current.reload()
    })
  }

  loadUserRights = async () => {
    let { userRights } = await Request.loadUserRights()
    this.setState({ studentList: userRights.Student });
  }

  restoreDroppedLead = async (recordId) => {
    this.setState({ loading: true })
    let response = await Request.restoreDroppedLead({ _id: recordId })
    this.setState({ loading: false })
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: response.message
      })
    }
    this.table.current.reload();
  }

  followUpsCallback(isFollowUpOverdue) {
    this.setState(
      {
        isFollowUpOverdue: isFollowUpOverdue,
      },
      () => {
        this.table.current.reload();
      }
    );
  }

  render() {
    const { dispatch } = this.props;
    const {
      drawerParam,
      drawer,
      allDesks,
      inquiryArr,
      ratingsObject,
      allCounsellor = [],
      allOperationManager = [],
      countryArr = [],
      deleteLoading,
      allBranches = [],
      deskColor,
      userCheckBox,
      ratingArr,
      subRatingArr,
      subRatingsObject,
      leadStatusArr,
      leadStatusesObject,
      modeArr,
      deskNameObj,
      counsellors,
      testTypeList,
      studentList,
      channelPartnerList
    } = this.state;

    const inputTypes = {
      fields: [
        { label: 'Choose Excel File', key: 'excelFile', type: 'file', required: true }
      ]
    }
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 }
      }
    }

    const {
      form: { getFieldDecorator, getFieldValue }
    } = this.props



    let columns = [
      {
        title: "Action ",
        key: "operation",
        dataindex: "operation",
        right: rightAuth.checkRights("actionColumn.view"),
        width: 220,
        maxWidth: 240,
        render: (text, record) => (
          <React.Fragment>
            <span className={styles.userSelectCheckbox}>
              <Checkbox
                checked={
                  userCheckBox[record._id]
                    ? userCheckBox[record._id].isChecked
                    : false
                }
                onChange={(y) => {
                  this.selectUser(y, record._id);
                }}
              />
            </span>

            <RightsWrapper myRight={"FollowUps.view"}>
              <Tooltip title="Notes">
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  onClick={() => this.openFollowUps(record)}
                  icon="calendar"
                />
              </Tooltip>
            </RightsWrapper>
            <Tooltip title="Click To Edit Details">
              {
                localUser.isFinanceAdmin || localUser.isFinanceAdmin ?
                  <Button
                    className={styles.btn}
                    shape="circle"
                    size={"small"}
                    href={(record.atLevel && desks[record.atLevel] ? desks[record.atLevel] : 'documents') + "?id=" + record._id}
                    icon="edit"
                  />
                  :
                  <Button
                    className={styles.btn}
                    shape="circle"
                    size={"small"}
                    href={"/documents?id=" + record._id}
                    icon="edit"
                  />
              }
            </Tooltip>
            <span>
              <Tooltip title="Change Student Branch ">
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  onClick={() =>
                    this.setState({ drawerParam: record, drawer: true })
                  }
                  icon="user"
                />
              </Tooltip>
            </span>
            {
              rightAuth.checkRights("changeStudentQuickDetails.view") ?
                <span>
                  <Tooltip title="Change Student Quick Details ">
                    <Button
                      className={styles.btn}
                      size={"small"}
                      shape="circle"
                      onClick={() =>
                        this.setState({ drawerParam: record, updateQuickDetailsDrawer: true })
                      }
                    >
                      <FaUserEdit />
                    </Button>
                  </Tooltip>
                </span>
                : null
            }

            {!record.movedToVisitorVisa ? (
              <RightsWrapper myRight={"moveStudentToVisitorVisaLead.view"}>
                <span>
                  <Tooltip title="Move Student for Visitor Visa ">
                    <Popconfirm
                      title="Are you sure to move student"
                      onConfirm={() => this.handleStudentMove(record)}
                    >
                      <Button
                        className={styles.btn}
                        size={"small"}
                        shape="circle"
                        icon="forward"
                      />
                    </Popconfirm>
                  </Tooltip>
                </span>
              </RightsWrapper>
            ) : null}
            {
              this.state.showDropped && (
                <RightsWrapper myRight={"showDropLead.view"}>
                  <Tooltip title="Restore Lead">
                    <Button loading={this.state.loading} shape="circle" icon="backward" size="small" onClick={() => this.restoreDroppedLead(record._id)}></Button>
                  </Tooltip>
                </RightsWrapper>
              )
            }
          </React.Fragment>
        ),
      },
      {
        title: "Photo",
        key: "profilePic",
        width: 55,
        dataIndex: "profilePic",
        right: rightAuth.checkRights("photoColumn.view"),
        render: (val) => {
          return <Avatar src={val} />;
        },
      },
      {
        title: "VID",
        key: "id",
        width: 100,
        dataIndex: "id",
        sorter: true,
        searchTextName: "id",
        right: rightAuth.checkRights("idColumn.view"),
        filterRegex: true,
      },
      {
        title: "Student Name",
        key: "studentName",
        width: 110,
        dataIndex: "studentName",
        sorter: true,
        searchTextName: "studentName",
        right: rightAuth.checkRights("nameColumn.view"),
        filterRegex: true,
        render: (item, record) => {
          return (
            <React.Fragment>
              <div
                className={
                  this.followUpExtendedDate(
                    record.followUp ? record.followUp : ""
                  )
                    ? styles.followUpExtendedDate
                    : ""
                }
              >
                <Tooltip>
                  <a
                    className={styles.btn}
                    target={"_blank"}
                    href={`/inquiry/studentProfileDetails?id=${record._id}`}
                  >
                    {item}
                  </a>
                </Tooltip>
              </div>
            </React.Fragment>
          );
        },
      },
      {
        title: "Passport Number",
        width: 120,
        key: "passportNumber",
        dataIndex: "profile.passportNumber",
        searchTextName: 'profile.passportNumber',
        right: rightAuth.checkRights("passportNumber.view")
      },
      {
        title: "DOB",
        width: 100,
        sorter: true,
        key: "dateOfBirth",
        dataIndex: "dateOfBirth",
        right: rightAuth.checkRights("dobColumn.view"),
        searchTextName: `${dateFormat}`,
        render: (val, record) => {
          return (
            <div>
              {record.dateOfBirth
                ? moment(record.dateOfBirth).format(dateFormat)
                : ""}
            </div>
          );
        },
      },
      {
        title: 'Institute Student Id',
        key: 'instituteStudentId',
        dataIndex: 'instituteStudentId',
        searchTextName: 'instituteStudentId',
        filterRegex: true,
        render: (item, record) => {
          return record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.instituteStudentId ? record.visaDesk.selectedCourse.instituteStudentId : record.instituteStudentId ? record.instituteStudentId : ''
        },
        width: 120,
        right: rightAuth.checkRights("instituteStudentId.view"),
      },
      {
        title: 'Final University / Course / Course Start Date',
        key: 'finalCourseUniversity',
        dataIndex: 'finalCourseUniversity',
        searchTextName: `University/Course/${dateFormat}`,
        width: 180,
        right: rightAuth.checkRights("instituteStudentId.view"),
        render: (text, record) => {
          if (
            !record ||
            !record.visaDesk ||
            !record.visaDesk.selectedCourse
          ) {
            return null;
          }
          const visaDesk = record.visaDesk;
          const selectedCourse = visaDesk.selectedCourse;
          const university = selectedCourse.universityInstitutionName || '';
          const course = selectedCourse.courseName || '';
          const courseStartDate = visaDesk.courseStartDate ? moment(visaDesk.courseStartDate).local().format(dateFormat) : "";

          if (!university && !course) {
            return null;
          }

          return (
            <div>
              <strong>{university}</strong>
              <hr />
              {course ? <div>{course}</div> : null}
              <hr />
              {courseStartDate}
            </div>
          );
        }
      },
      {
        title: 'Final Country',
        key: 'finalCountry',
        width: 100,
        filters: this.state.countriesArr,
        right: rightAuth.checkRights("instituteStudentId.view"),
        render: (text, record) => {
          let finalCountryId = record && record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.countryId ? record.visaDesk.selectedCourse.countryId : null;
          let foundCountry = this.state.countriesArr.find((country) => country.value === finalCountryId);
          return (
            <div>{foundCountry ? foundCountry.text : ""}</div>
          )
        }
      },
      {
        title: 'Channel Partner',
        key: 'channelParner',
        width: 150,
        dataIndex: 'channelParner',
        right: rightAuth.checkRights("showChannelPartner.view"),
        filters: channelPartnerList && channelPartnerList.map(x => ({
          value: x._id,
          text: x.channelPartnerName
        })),
        render: (text, record) => {
          let found

          let channelPartnerId = null;

          if (record && record.visaDesk) {
            if (record.visaDesk.channelPartnerId) {
              channelPartnerId = record.visaDesk.channelPartnerId;
            } else if (
              record.visaDesk.selectedCourse &&
              record.visaDesk.selectedCourse.channelPartnerId
            ) {
              channelPartnerId = record.visaDesk.selectedCourse.channelPartnerId;
            }
          }
          // console.log(channelPartnerId);
          if (channelPartnerId && channelPartnerId != '') {
            found = _.find(channelPartnerList, (item) => {
              return item._id === channelPartnerId
            })
          }
          return (<div>
            <div style={{ color: '#ffa500' }}>{found ? found.channelPartnerName : record.visaDesk && record.visaDesk.selectedCourse && record.visaDesk.selectedCourse.universityPartnership ? record.visaDesk.selectedCourse.universityPartnership : null}</div>
          </div>)
        }
      },
      {
        title: "Test Type",
        width: 100,
        key: "testType",
        dataIndex: "testType",
        right: rightAuth.checkRights("testType.view"),
        filters: testTypeList ? testTypeList : [],

      },
      {
        title: "Student Register From ",
        width: 180,
        key: "studentRegisterFrom",
        dataIndex: "studentRegisterFrom",
        right: rightAuth.checkRights("studentRegisterFromColumn.view"),
        render: (val, record) => {
          return (
            <div>
              {record.studentRegisterFrom
                ? record.studentRegisterFrom
                : "Reception Desk"}
            </div>
          );
        },
      },
      {
        title: "At Stage",
        key: "atLevel",
        dataIndex: "atLevel",
        width: 150,
        sorter: true,
        filters: this.getAtStageFilters(),
        right: rightAuth.checkRights("atStageColumn.view"),
        render: (val, record) => {
          return this.returnDeskName(record);
        },
      },
      {
        title: "Registration Date",
        width: 100,
        key: "moveDeskDate.moveToRegistrationDesk",
        dataIndex: "moveDeskDate.moveToRegistrationDesk",
        right: rightAuth.checkRights("registrationDateColumn.view"),
        width: 140,
        render: (text, record) => {
          return <div>{text ? moment(text).format("lll") : ""}</div>;
        },
      },

      // {
      //   title: "Mobile",
      //   width: 100,
      //   key: "mobile",
      //   dataIndex: "mobile",
      //   searchTextName: "mobile",
      //   right: rightAuth.checkRights("mobileColumn.view"),
      //   filterRegex: true,
      //   render: (val, record) => {
      //     return (
      //       <div>
      //         {" "}
      //         {record.mobile &&
      //           record.mobile.length == 10 &&
      //           rightAuth.checkRights("ShowClickToCall.view") ? (
      //           <Tooltip title="Start Call">
      //             <Button
      //               className="ant-btn ant-btn-primary"
      //               onClick={(e) => {
      //                 dispatch(showLoader());
      //                 Request.callInitiate({
      //                   mobile: record.mobile,
      //                 }).then(({ data, error, message }) => {
      //                   dispatch(hideLoader());
      //                   if (!error) {
      //                     notification.success({
      //                       message: message,
      //                     });
      //                   } else {
      //                     notification.error({
      //                       message: message,
      //                     });
      //                   }
      //                 });
      //               }}
      //             >
      //               Click To Call
      //             </Button>
      //           </Tooltip>
      //         ) : (
      //           record.mobile
      //         )}
      //       </div>
      //     );
      //   },
      // },
      {
        title: 'Mobile',
        width: 100,
        key: 'mobile',
        dataIndex: 'mobile',
        searchTextName: "mobile",
        right: rightAuth.checkRights("mobileColumn.view"),
        filterRegex: true,
        render: (val, record) => {
          return (
            <div>
              {" "}
              {record.mobile &&
                record.mobile.length >= 10 &&
                rightAuth.checkRights("ShowClickToCall.view") ? (
                <Tooltip title="Start Call">
                  <Button
                    className="ant-btn ant-btn-primary"
                    onClick={() => {
                      this.setState({ showCallDrawer: true, recordForCall: record })
                    }}
                  // onClick={(e) => {

                  //   dispatch(showLoader());
                  //   Request.callInitiate({
                  //     mobile: record.mobile,
                  //   }).then(({ data, error, message }) => {
                  //     dispatch(hideLoader());
                  //     if (!error) {
                  //       notification.success({
                  //         message: message,
                  //       });
                  //     } else {
                  //       notification.error({
                  //         message: message,
                  //       });
                  //     }
                  //   });
                  // }}
                  >
                    Click To Call
                  </Button>
                </Tooltip>
              ) : (
                record.mobile
              )}
            </div>
          )
        }
      },
      {
        title: "WhatsApp",
        width: 140,
        key: "watsupp",
        dataIndex: "watsupp",
        searchTextName: "watsupp",
        right: rightAuth.checkRights("whatsAppColumn.view"),
        filterRegex: true,
        render: (val, record) => {
          return val && val.length == 10 ? (
            <Tooltip title="Share on Whatsapp">
              <a
                target={"_blank"}
                className="ant-btn ant-btn-primary"
                href={`http://api.whatsapp.com/send?phone=${val}&text=&source=&data=`}
              >
                Send WhatsApp
              </a>
            </Tooltip>
          ) : null;
        },
      },
      {
        title: "Source",
        width: 100,
        key: "mode",
        right: rightAuth.checkRights("modeColumn.view"),
        filters: modeArr && modeArr.map((x) => ({ value: x, text: x })),
      },
      {
        title: "Rating",
        width: 100,
        key: "counsellingDesk.rating",
        right: rightAuth.checkRights("ratingColumn.view"),
        filters:
          ratingArr &&
          ratingArr.map((x) => ({ value: x._id, text: x.ratingName })),
        render: (val, record) => {
          let ratingObject = ratingsObject[val];
          return (
            <div>
              {ratingObject ? (
                <div
                  className="antd-pro-containers-desk-counselling-all-styles-rating"
                  style={{
                    background: ratingObject.ratingColor,
                    borderColor: ratingObject.ratingColor,
                  }}
                >
                  {ratingObject.ratingName}
                </div>
              ) : (
                this.renderStatus(val)
              )}
            </div>
          );
        },
      },
      {
        title: "Quality Rating",
        width: 120,
        key: "counsellingDesk.qualityRating",
        right: rightAuth.checkRights("qualityRatingColumn.view"),
        filters: ["Qualified", "Potential", "Unqualified"].map(x => ({ value: x, text: x })),
        render: (val, record) => {
          return record.counsellingDesk && record.counsellingDesk.qualityRating ? record.counsellingDesk.qualityRating : "-";
        }
      },
      {
        title: "Tag(Subrating)",
        width: 120,
        key: "counsellingDesk.subRating",
        right: rightAuth.checkRights("subRatingColumn.view"),
        filters: subRatingArr && subRatingArr.map((x) => ({ value: x._id, text: x.subRatingName })),
        render: (val, record) => {
          let srId = record.counsellingDesk && record.counsellingDesk.subRating;
          let srObj = srId ? subRatingsObject[srId] : null;
          return srObj ? srObj.subRatingName : "-";
        }
      },
      {
        title: "Lead Status",
        width: 120,
        key: "leadStatus",
        right: rightAuth.checkRights("leadStatusColumn.view"),
        filters: leadStatusArr && leadStatusArr.map((x) => ({ value: x._id, text: x.statusName })),
        render: (val, record) => {
          let lsId = record.leadStatus;
          let lsObj = lsId ? leadStatusesObject[lsId] : null;
          return lsObj ? lsObj.statusName : "-";
        }
      },
      {
        title: "Counsellor",
        key: "counsellorId",
        width: 110,
        right: rightAuth.checkRights("counsellorColumn.view"),
        filters: allCounsellor.map((x) => ({ value: x._id, text: x.name })),
        render: (text, record) => {
          return (
            <div>{record.counsellorId ? record.counsellorId.name : ""}</div>
          );
        },
      },
      {
        title: "Operation Manager",
        key: "operationManagerId",
        right: rightAuth.checkRights("operationManagerColumn.view"),
        width: 110,
        filters: allOperationManager.map((x) => ({
          value: x._id,
          text: x.name,
        })),
        render: (text, record) => {
          return (
            <div>
              {record.operationManagerId ? record.operationManagerId.name : ""}
            </div>
          );
        },
      },
      {
        title: "Branch",
        width: 100,
        key: "studentBranchId",
        right: rightAuth.checkRights("branchColumn.view"),
        filters: allBranches,
        render: (text, record) => {
          return (
            <div>
              {record.studentBranchId ? record.studentBranchId.branchName : ""}
            </div>
          );
        },
      },
      {
        title: "Preference",
        key: "preference",
        width: 110,
        searchTextName: "preference",
        right: rightAuth.checkRights("preferenceColumn.view"),
        filterRegex: true,
        render: (val, row) => {
          return row.totalPreference ? (
            <ul className={common.ul}>
              {row.totalPreference.map((val, inde) => {
                return <li key={inde}>{val.country}</li>;
              })}
            </ul>
          ) : null;
        },
      },
      {
        title: "Follow Up",
        key: "followUp",
        width: 200,
        dataIndex: "followUp",
        right: rightAuth.checkRights("followUPColumn.view"),
        render: (text, record) => {
          return <LatestFollowUp info={text} />;
        },
      },
      {
        title: "Last Updated By",
        width: 150,
        key: "updatedByUser",
        dataIndex: "updatedByUser",
        right: rightAuth.checkRights("lastUpdatedByColumn.view"),
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).local().format("lll") : ""}</small>
            </div>
          );
        },
      },
      {
        title: "Action",
        key: "_id",
        dataindex: "_id",
        right: rightAuth.checkRights("actionColumn.view"),
        width: 100,
        render: (val, record) => (
          <React.Fragment>
            <RightsWrapper myRight={"Student.delete"}>
              <Tooltip title="Delete Student ">
                <Popconfirm
                  title="Are you sure delete this student?"
                  onConfirm={() => {
                    this.deleteStudent(val);
                  }}
                  onCancel={() => {
                    console.log();
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    loading={deleteLoading}
                    className={styles.btn}
                    size={"small"}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        ),
      },
    ];

    columns = lodash.filter(columns, (x) => {
      return x.right == true;
    });
    let pathName = this.props.location.pathname;
    return (
      <PageHeaderWrapper
        title={`${pathName === "/allLeads" ? "LEADS" : "STUDENTS LIST"} : ${this.state.count}`}
        followUpsCallback={this.followUpsCallback}
      >
        {
          this.state.showChangeMultipleCounsellor ?
            <ChangeCounsellorAndDesk usersData={counsellingData.usersData} onClose={this.closeChangeMultipleCounsellorDrawer} />
            : null
        }
        {this.state.showFollowUp ? (
          <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
        ) : null}

        {drawer && (
          <ChangeBranch
            param={drawerParam}
            onClose={() => {
              this.setState({ drawer: false }, () => {
                this.table.current.reload();
              });
            }}
          />
        )}

        {this.state.updateQuickDetailsDrawer && (
          <ChangeQuickDetails
            param={drawerParam}
            onClose={() => {
              this.setState({ updateQuickDetailsDrawer: false }, () => {
                this.table.current.reload();
              });
            }}
          />
        )}
        {
          this.state.showCallDrawer ?
            <ClickToCallDrawer record={this.state.recordForCall} type="inquiry" onClose={this.closeCallDrawer} />
            : null
        }

        {this.state.showWhatsAppSms ? (
          <WhatsAPPSMS
            counsellingData={counsellingData}
            onClose={this.closeWhatsSMS}
          />
        ) : null}

        {this.state.showSMS ? (
          <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
        ) : null}

        {this.state.showEmail ? (
          <EmailDrawer
            counsellingData={counsellingData}
            onClose={this.closeEmail}
          />
        ) : null}

        <Card style={{ marginBottom: 10 }}>
          <Row gutter={16} align="middle">
            <Col span={6}>
              <h4>FILTER BY CREATED DATE</h4>
              <RangePicker
                key={this.state.showDate ? "78" : "326"}
                showTime={{ format: "HH:mm" }}
                format="YYYY-MM-DD"
                placeholder={["Start Date", "End Date"]}
                onChange={this.chooseRangerPicker}
                onOk={this.onOk}
                style={{ width: "100%" }}
              />
            </Col>

            <Col span={6}>
              <h4>FILTER BY REGISTRATION DATE</h4>
              <RangePicker
                key={this.state.showRegiDate ? "78" : "326"}
                showTime={{ format: "HH:mm" }}
                format="YYYY-MM-DD"
                placeholder={["Start Date", "End Date"]}
                onChange={this.chooseRegistrationPicker}
                onOk={this.onRegistrationOk}
                style={{ width: "100%" }}
              />
            </Col>

            <Col span={2}>
              <RightsWrapper myRight={"Student.add"}>
                <Button
                  type="primary"
                  style={{ width: "100%" }}
                  onClick={() => window.open("/inquiry/add", "_blank")}
                >
                  Add
                </Button>
              </RightsWrapper>
            </Col>

            <Col span={3}>
              <Button
                type="primary"
                style={{ width: "100%", marginBottom: 5 }}
                onClick={() => this.setState({ visible1: true })}
              >
                Add Excel File
              </Button>
            </Col>

            <Col span={4}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={() => {
                  this.setState({ showMissingQual: true }, () => {
                    this.table.current.reload();
                  });
                }}
              >
                Missing Qualification
              </Button>
            </Col>
          </Row>
        </Card>

        <Card style={{ marginBottom: 10 }}>
          <div className={styles.filterBlock}>
            <div style={{ display: "flex" }}>
              {counsellors && counsellors.length ? (
                <div style={{ float: "left" }}>
                  <Select
                    allowClear
                    style={{
                      width: 225,
                      marginRight: 16,
                    }}
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.counsellorId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={(counsellorId) => {
                      this.setState(
                        {
                          counsellorId: counsellorId && counsellorId.toString(),
                        },
                        () => {
                          setTimeout(() => {
                            this.table.current.reload();
                          }, 500);
                        }
                      );
                    }}
                  >
                    {counsellors.map((val, idn) => {
                      return (
                        <Option key={idn} value={val.id}>
                          {val.display}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              ) : null}
              <Select
                allowClear
                style={{
                  width: 214,
                  paddingRight: 16,
                  paddingLeft: 9,
                  color: deskColor,
                }}
                value={deskNameObj[this.state.deskId]}
                placeholder="Select Desk"
                onChange={(deskId) => {
                  if (deskId) {
                    deskId = JSON.parse(deskId);
                    this.setState(
                      {
                        deskId: deskId && deskId.name.toString(),
                        deskColor: deskId.color,
                      },
                      () => {
                        this.table.current.reload();
                      }
                    );
                  } else {
                    this.setState({ deskId: "", deskColor: "" }, () => {
                      this.table.current.reload();
                    });
                  }
                }}
              >
                {allDesks.map((val, idn) => {
                  return (
                    <Option key={idn} value={JSON.stringify(val)}>
                      <Row>
                        <Col span={20}> {deskNameObj[val.name]} </Col>
                        <Col span={4}>
                          <div
                            style={{
                              paddingTop: 10,
                              backgroundColor: val.color,
                            }}
                          />
                        </Col>
                      </Row>
                    </Option>
                  );
                })}
              </Select>
            </div>
            <div className={styles.myBtnGroup}>
              <Button
                className={styles.btn}
                type="primary"
                onClick={() => this.showEmail()}
              >
                Send E-mail
              </Button>

              <Button
                type="primary"
                className={styles.btn}
                onClick={() => this.showSMS()}
              >
                Send SMS
              </Button>

              <Button
                type="primary"
                className={styles.btn}
                onClick={() => this.showWhatsAppSms()}
              >
                {" "}
                Whatsapp
              </Button>

              <Button
                className={styles.btn}
                onClick={() => this.selectAllUserFxn()}
              >
                Select Visible
              </Button>

              <Button
                className={styles.btn}
                onClick={() => this.unselectAllUserFxn()}
              >
                Unselect Visible
              </Button>
            </div>
          </div>
        </Card>
        <Card>
          <Search id="search-student-input" placeholder="Search Student" onSearch={value => this.changeSearchValue(value)} enterButton />
          {/* <Input
            type='text'
            enterButton
            value={this.state.search_keyword}
            onChange={(e) => { this.setState({ search_keyword: e.target.value }) }}
            onKeyPress={(e) => { this.checkActiveKey(e) }}
            placeholder="Search Student"
            id='search-student-input'
          /> */}

        </Card>
        {
          showDroppedLeads || showDropLead ?
            <Card bordered={true} style={{ marginBottom: 10 }}>
              <Row>
                <Col span={4}>
                  <RightsWrapper myRight={"dropLead.view"}>
                    <Popconfirm
                      title="Are you sure to drop this inquiry?"
                      onConfirm={() => {
                        this.dropLeads()
                      }}
                      onCancel={() => {
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        className={styles.btn}
                        type="primary">Drop Selected Leads
                      </Button>
                    </Popconfirm>
                  </RightsWrapper>
                </Col>
                <Col span={4}>
                  <RightsWrapper myRight={"showDropLead.view"}>
                    <Button
                      className={styles.btn}
                      type="primary"
                      onClick={() => {
                        this.toggleDroppedLeads()
                      }}
                    >{this.state.showDropped ? "Show All Leads" : 'Show Dropped Leads'}
                    </Button>
                  </RightsWrapper>
                </Col>
                <Col span={4}>
                  <RightsWrapper myRight={"changeCounsellor.view"}>
                    <Popconfirm
                      title="Are you sure to make this change?"
                      onConfirm={() => {
                        this.changeMultipleCounsellorAndDesk()
                      }}
                      onCancel={() => {
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        className={styles.btn}
                        type="primary">Change Counsellor & Desk
                      </Button>
                    </Popconfirm>
                  </RightsWrapper>
                </Col>
              </Row>

            </Card>
            : null
        }

        <Card bordered={true}>
          <TableComp
            id={"allstudents"}
            showSelector={true}
            columns={columns}
            ref={this.table}
            apiRequest={(params) => this.apiRequest(params, columns)}
            extraProps={{ scroll: { x: 1800 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>
        {this.state.visible1 && <Drawer
          title=""
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              visible1: false
            })
          }}
          visible={this.state.visible1}
          width={500}>
          <div>
            <Card bordered={true}>
              <div>

                <Form onSubmit={this.handleSubmit} {...formItemLayout} style={{ marginTop: 8 }}>
                  <GetAllFormFields apiurl={LAPI_URL}
                    inputSchema={inputTypes}
                    getFieldDecorator={getFieldDecorator} />

                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginLeft: '10%' }}
                    loading={this.state.loading}>
                    UPLOAD

                  </Button>

                  <a href={LeadImportExcel} download={'lead-sample.xlsx'}>
                    <Button
                      type="default"
                      style={{ marginLeft: '10%' }}
                      loading={this.state.loading}>
                      DOWNLOAD SAMPLE FILE
                    </Button>
                  </a>
                </Form>

              </div>


            </Card>
          </div>
        </Drawer>}
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
  location: router.location,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllInquiry);
